import { SVGProps, Ref, forwardRef } from 'react';

export const ComputerOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 13.499c-4.365-.04-5-.913-5-6.249C0 1.781.667 1 5.333 1h5.334C15.333 1 16 1.781 16 7.25c0 5.336-.635 6.21-5 6.249V15H5zm.333-1.399c-1.153 0-1.94-.051-2.5-.175-.53-.117-.736-.272-.851-.408-.138-.161-.306-.481-.423-1.205S1.4 8.608 1.4 7.25s.043-2.337.16-3.061c.116-.724.284-1.045.422-1.206.115-.136.322-.292.851-.408.56-.124 1.347-.175 2.5-.175h5.334c1.153 0 1.94.051 2.5.175.53.116.736.272.851.408.138.161.306.482.423 1.206s.159 1.703.159 3.061-.043 2.337-.16 3.062c-.116.724-.284 1.044-.422 1.205-.115.136-.322.292-.851.408-.56.124-1.347.175-2.5.175z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ComputerOutlinedSize16Glyph.displayName = 'ComputerOutlinedSize16Glyph';
